import React from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, Dropdown } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuth } from '../../AuthContext';
import { useDropdownDelay } from '../../hooks/useDropdownDelay';

const AccountSelector = () => {
  const { getAvailableAccounts, switchAccount, selectedAccountIndex } = useAuth();
  const { isOpen, toggle, handleMouseEnter, handleMouseLeave } = useDropdownDelay();

  const availableAccounts = getAvailableAccounts();

  // Don't render if user only has one account
  if (availableAccounts.length <= 1) {
    return null;
  }

  return (
    <Dropdown
      nav
      inNavbar
      isOpen={isOpen}
      toggle={toggle}
      onMouseOver={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <DropdownToggle nav className="px-0 pr-3">
        <FontAwesomeIcon icon="sign-in-alt" className="fs-2" />
      </DropdownToggle>
      <DropdownMenu right className="dropdown-menu-card">
        <div className="bg-white rounded-soft py-2">
          <div className="px-3 pb-2">
            <small className="text-uppercase text-600 font-weight-bold">Switch Account</small>
          </div>
          {availableAccounts.map((account) => {
            // Filter out "Basic" role and show meaningful roles
            const displayRoles = account.roles ? account.roles.filter(role => role !== 'Basic') : [];
            const roleText = displayRoles.length > 0 ? displayRoles.join(', ') : 'Basic';
            
            return (
              <DropdownItem
                key={account.index}
                onClick={() => switchAccount(account.index)}
                active={account.index === parseInt(selectedAccountIndex, 10)}
              >
                <div className="d-flex align-items-center justify-content-between w-100">
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={account.index === parseInt(selectedAccountIndex, 10) ? "check-circle" : "circle"}
                      className="mr-2"
                      style={{ color: account.index === parseInt(selectedAccountIndex, 10) ? '#2c7be5' : '#d8e2ef' }}
                    />
                    <div>
                      <strong>{account.accountKey}</strong>
                      <div className="text-muted fs--2">{roleText}</div>
                    </div>
                  </div>
                </div>
              </DropdownItem>
            );
          })}
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default AccountSelector;
